import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function TermsOfServicePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-full bg-[#0A0A0A] relative z-[1] pb-12">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button
          onClick={() => navigate(-1)}
          variant="ghost"
          className="mb-8 text-[#D4B483] hover:bg-[#1A1A1A]"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Tillbaka
        </Button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="font-playfair text-4xl font-bold text-[#EDEDED] mb-2">Allmänna Villkor</h1>
          <p className="text-[#9A9AA2] text-sm mb-8">Senast uppdaterad: 28 juni 2026</p>
          <div className="text-[#D4D4D8] space-y-6 leading-relaxed">
            <p>
              Genom att använda Bästa Bitens beställningssystem godkänner du följande villkor. Läs därför igenom dessa noggrant innan du slutför din beställning.
            </p>
            <div className="bg-[#121212] border border-[#27272A] rounded-xl p-5 text-sm space-y-1">
              <p className="font-semibold text-[#EDEDED] mb-1">Företagsuppgifter</p>
              <p>Bästa Biten</p>
              <p>Organisationsnummer: [ORG.NR]</p>
              <p>Adress: [POSTADRESS]</p>
              <p>Telefon: [TELEFON]</p>
              <p>Kontakt: via meddelandefunktionen på din profilsida (Min Profil → Kontakta oss)</p>
            </div>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">1. Beställning och Bekräftelse</h2>
            <p>
              När du slutför en order på vår hemsida eller i vår app får du en digital orderbekräftelse. Avtalet om köp anses ingått först när restaurangen har godkänt din order.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">2. Betalning</h2>
            <p>
              Bästa Biten erbjuder vid nuvarande tidpunkt inga betalningar via hemsidan. All betalning sker fysiskt i samband med avhämtning på restaurangen eller vid hemleverans. Du accepterar att du är betalningsskyldig för den mat du har beställt.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">3. Ångerrätt och Reklamation</h2>
            <p>
              Enligt distansavtalslagen gäller normalt inte ångerrätt på livsmedel. Om maten emellertid är felaktig eller skadad ber vi dig kontakta oss omedelbart — ring oss eller skriv via <span className="text-[#EDEDED] font-medium">Min Profil → Kontakta oss</span> — så byter vi ut varan eller ger dig återbetalning i enlighet med konsumentlagstiftningen.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">4. Ansvarsbegränsning</h2>
            <p>
              Vi reserverar oss för eventuella tekniska fel, slutförsäljning av varor och skrivfel på webbplatsen. Vid händelser utanför vår kontroll (Force Majeure) ansvarar Bästa Biten inte för förseningar eller misslyckade leveranser.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">5. Ändring av Villkor</h2>
            <p>
              Vi förbehåller oss rätten att när som helst ändra dessa allmänna villkor. De villkor som fanns vid tidpunkten för din beställning är de som gäller för just det köpet.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
